import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'

export default function FacilityEditModal({ modalOpen, body, onClose }) {
  return (
    <Modal isOpen={modalOpen} toggle={onClose}>
      <ModalHeader toggle={onClose}>
        <div>Update Facility</div>
        <small>
          Email will <b>NOT</b> be sent to Purchaser POC using billing contact
          info below.
        </small>
      </ModalHeader>
      <ModalBody className="px-0">{body}</ModalBody>
    </Modal>
  )
}
